import { render, staticRenderFns } from "./p21.vue?vue&type=template&id=518c4efc&scoped=true&"
import script from "./p21.vue?vue&type=script&lang=js&"
export * from "./p21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c4efc",
  null
  
)

export default component.exports